import React, { useState, useEffect } from "react";
import ListLayout from "../../../../../partials/content/ListLayout";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { getInvoiceDetail } from "../../../../../services/finance/invoice";
import InvoiceBasicInfo from "./invoiceBasicInfo";
import InvoicePayments from "./invoicePayments";
import InvoicePrintOut from "./invoicePrintOut";
import Notes from "../../../common/notes";
import Attachments from "../../../common/attachments";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const InvoiceDetail = ({ match, history }) => {
  const { reload } = useGlobalData();
  const invoiceID = match.params.invoiceID;
  const [invoice, setInvoice] = useState({ ID: 0 });
  const [approvalProcess, setApprovalProcess] = useState([]);
  const [approvalSteps, setApprovalSteps] = useState([]);
  const [approvalActiveStep, setApprovalActiveStep] = useState(0);
  const [component, setComponent] = useState(null);
  const [headerTitle, setHeaderTitle] = useState("Basic Info");
  const [listMenu, setListMenu] = useState([
    {
      key: "basicInfo",
      label: "Basic Info",
      icon: "fas fa-th-large",
    },
    {
      key: "payments",
      label: "A/R Payments",
      icon: "fas fa-credit-card",
    },
    {
      key: "attachments",
      label: "Attachments",
      icon: "fas fa-paperclip",
    },
    {
      key: "notes",
      label: "Notes",
      icon: "fas fa-sticky-note",
    },
    {
      key: "printOut",
      label: "PrintOut",
      icon: "fas fa-print",
    },
  ]);

  const defaultSelected = "basicInfo";

  useEffect(() => {
    getInvoiceData();
  }, [invoiceID, reload]);

  const actionButtons = [
    {
      title: "",
      color: "label-brand",
      icon: "fas fa-backward",
      onClick: () => {
        history.push("/finance/invoices/AR");
      },
    },
  ];
  if (
    invoice.edit &&
    (invoice.approvalProcessID === 0 ||
      invoice.approvalProcess.statusID === 2 ||
      invoice.approvalProcess.statusID === 3) &&
    invoice.paymentStatus === 1 &&
    invoice.docRef !== "4" &&
    invoice.docRef !== "5"
  ) {
    actionButtons.push({
      title: "Edit A/R Invoice",
      color: "primary",
      icon: "fas fa-edit",
      onClick: () => {
        history.push("/finance/edit-invoice/" + invoiceID);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title={headerTitle ? headerTitle : "Basic Info"}
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/invoices/AR",
            title: "Invoices",
            active: false,
          },
          {
            page: "/finance/invoice-detail/" + invoiceID,
            title: "A/R Invoice ID " + invoice.invoiceCode,
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        <ListLayout
          component={component}
          listMenu={listMenu}
          onSelectItem={(key) => {
            let selectedComponent;
            switch (key) {
              case "basicInfo":
                selectedComponent = (
                  <InvoiceBasicInfo
                    invoiceImp={invoice}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
              case "payments":
                selectedComponent = (
                  <InvoicePayments invoiceID={invoice.ID} history={history} />
                );
                setHeaderTitle("Payments");
                break;
              case "attachments":
                selectedComponent = (
                  <Attachments docType="INVO" docID={invoice.ID} />
                );
                setHeaderTitle("Attachments");
                break;
              case "notes":
                selectedComponent = <Notes docType="INVO" docID={invoice.ID} />;
                setHeaderTitle("Notes");
                break;
              case "printOut":
                selectedComponent = <InvoicePrintOut invoice={invoice} />;
                setHeaderTitle("Print Out");
                break;
              default:
                selectedComponent = (
                  <InvoiceBasicInfo
                    invoiceImp={invoice}
                    approvalProcessImp={approvalProcess}
                    approvalStepsImp={approvalSteps}
                    approvalActiveStepImp={approvalActiveStep}
                  />
                );
                setHeaderTitle("Basic Info");
                break;
            }
            setComponent(selectedComponent);
          }}
          defaultSelected={defaultSelected}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function getInvoiceData() {
    const response = await getInvoiceDetail(invoiceID);
    const { data } = response.data;
    const componentTmp = (
      <InvoiceBasicInfo
        invoiceImp={data.invoice}
        approvalProcessImp={data.approvalProcess}
        approvalStepsImp={data.invoice.approvalProcess.approval.approvalValue}
        approvalActiveStepImp={data.invoice.approvalProcess.level}
      />
    );
    setInvoice(data.invoice);
    setApprovalProcess(data.approvalProcess);
    setApprovalSteps(data.invoice.approvalProcess.approval.approvalValue);
    setApprovalActiveStep(data.invoice.approvalProcess.level);
    setComponent(componentTmp);
  }
};

export default InvoiceDetail;
